import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({
  ssoCorporateGroupId = '',
  ssoCorporateGroupCompanyId = '',
  ...params
}) => {
  return await dponetAPI.get(
    `/sso_corporate_groups/${ssoCorporateGroupId}/sso_corporate_group_companies/${ssoCorporateGroupCompanyId}`,
    { params },
  )
}

const create = async ({ ssoCorporateGroupId = '', companyId = '' }) => {
  return await dponetAPI.post(
    `/sso_corporate_groups/${ssoCorporateGroupId}/sso_corporate_group_companies`,
    { companyId: companyId },
  )
}

const destroy = async ({
  ssoCorporateGroupId = '',
  ssoCorporateGroupCompanyId = '',
}) => {
  return await dponetAPI.delete(
    `/sso_corporate_groups/${ssoCorporateGroupId}/sso_corporate_group_companies/${ssoCorporateGroupCompanyId}`,
  )
}

const ssoCorporateGroupCompanies = {
  get,
  create,
  destroy,
}

export default ssoCorporateGroupCompanies
